import { type FormValidateInput } from '@mantine/form';
import { isSupportedCalculationRule, type UpdateTraderRateRequest } from '../../model';

const isValidNumber = (value: string | undefined): boolean => {
    if (!value || value.trim() === '') {
        return false;
    }

    const num = parseFloat(value);

    return !isNaN(num) && isFinite(num);
};

export const validateCommission = (value: unknown) => {
    const val = String(value);

    if (val.trim() === '') {
        return 'Обязательное поле';
    }

    if (!isValidNumber(val)) {
        return 'Должно быть числом';
    }

    if (parseFloat(val) < 0) {
        return 'Должно быть неотрицательным числом';
    }

    return null;
};

export const validateCalculationRule = (value?: string) => {
    if (!value) {
        return 'Обязательное поле';
    }

    if (!isSupportedCalculationRule(value)) {
        return 'Выберите правило расчёта из списка';
    }

    return null;
};

export const validateTraderRate: FormValidateInput<UpdateTraderRateRequest> = {
    commission: {
        value: validateCommission,
    },
    calculationRule: validateCalculationRule,
};
